import React from 'react';
import { Link } from 'react-router-dom';
import { MicroProfileForm } from '@/components/profile/MicroProfileForm';

export const Profile: React.FC = () => {
    return (
        <div className="min-h-screen bg-slate-50 py-12 px-4 text-slate-900">
            <div className="max-w-6xl mx-auto space-y-10">
                <header className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                    <div>
                        <p className="text-xs uppercase tracking-[0.3em] text-slate-400">Lyra micro</p>
                        <h1 className="text-2xl font-semibold text-slate-900">Your Personal Hub</h1>
                        <p className="text-sm text-slate-500">
                            Manage your preferences and track your learning journey.
                        </p>
                    </div>
                    <nav className="flex flex-wrap items-center gap-3 text-sm text-slate-600">
                        <Link className="hover:text-slate-900 underline-offset-4 hover:underline" to="/micro-dashboard">
                            Micro Dashboard
                        </Link>
                    </nav>
                </header>

                <MicroProfileForm mode="default" />
            </div>
        </div>
    );
};

export default Profile;
